"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKETPLACE_PRODUCT_TYPE = exports.MARKETPLACE_ENTITY_TYPE = void 0;
var MARKETPLACE_ENTITY_TYPE = {
  OFFERS: 'offers'
};
exports.MARKETPLACE_ENTITY_TYPE = MARKETPLACE_ENTITY_TYPE;
var MARKETPLACE_PRODUCT_TYPE = {
  BANKING: 'banking'
};
exports.MARKETPLACE_PRODUCT_TYPE = MARKETPLACE_PRODUCT_TYPE;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJNQVJLRVRQTEFDRV9FTlRJVFlfVFlQRSIsIk9GRkVSUyIsImV4cG9ydHMiLCJNQVJLRVRQTEFDRV9QUk9EVUNUX1RZUEUiLCJCQU5LSU5HIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvd2VhbHRoLW1pbmktcHJvZHVjdC1jYXJkL2NvbnN0YW50cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgTUFSS0VUUExBQ0VfRU5USVRZX1RZUEUgPSB7XG4gIE9GRkVSUzogJ29mZmVycycsXG59O1xuXG5leHBvcnQgY29uc3QgTUFSS0VUUExBQ0VfUFJPRFVDVF9UWVBFID0ge1xuICBCQU5LSU5HOiAnYmFua2luZycsXG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBTyxJQUFNQSx1QkFBdUIsR0FBRztFQUNyQ0MsTUFBTSxFQUFFO0FBQ1YsQ0FBQztBQUFDQyxPQUFBLENBQUFGLHVCQUFBLEdBQUFBLHVCQUFBO0FBRUssSUFBTUcsd0JBQXdCLEdBQUc7RUFDdENDLE9BQU8sRUFBRTtBQUNYLENBQUM7QUFBQ0YsT0FBQSxDQUFBQyx3QkFBQSxHQUFBQSx3QkFBQSJ9